<template>
  <div class="col-lg-4">
    <div class="box box--gtm">
      <div class="box-img-wrapper">
        <VideoWrapper v-if="solution.videoURL" :videoLink="solution.videoURL" :withoutPlayButton="true"></VideoWrapper>
        <ImageWrapper v-else :file="solution.idFile" :key="solution.idFile"></ImageWrapper>
        <span v-if="contentType && contentType.value" class="box-img-tag-top d-none d-lg-flex"><span>{{contentType.value}}</span></span>
      </div>
      <div class="box-inner">
        <span class="box-title">{{solution.headline}}</span>
        <p>{{solution.lead}}</p>
        <router-link class="box-link" v-if="slug" :to="{name: 'SolutionProcess', params: {slug: slug, id: solution.idSolution}}">
          Read more
        </router-link>
        <router-link class="box-link" v-else :to="{name: 'SolutionMain', params: {id: solution.idSolution}}">
          Read more
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {readTime} from "@/helpers/readTime";
import VideoWrapper from "@/components/general/VideoWrapper";
import settings from "@/settings";
export default {
  components: {VideoWrapper, ImageWrapper},
  props: ['solution', 'slug'],
  name: "SolutionBox",
  computed: {
    contentType() {
      return this.$store.getters.settingsCompanyBySettingTypeCodeAndID(settings.SETTING_TYPES.SOLUTIONS_CONTENT_TYPES, this.solution.idContentType)
    }
  },
  methods: {
    readTime: readTime
  }
}
</script>

<style scoped>

</style>